import React, { useEffect, useState, useRef } from "react";
import { httpService } from "../httpService";
import logo from "./logo.png";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import { Button } from "@mui/material";
function JambTagsPrintout() {
  const [staff, setStaff] = useState([]);
  const componentRef = useRef();
  const getStaffTags = async () => {
    const { data, error } = await httpService("getalljambstafftags");

    if (data) {
      setStaff(data);
      console.log(data);
    }
    if (error) {
    }
  };

  useEffect(() => {
    getStaffTags();
  }, []);
  return (
    <div>
      <div className="mt-5 mb-3 container">
        <h4>Print JAMB Tags</h4>
        <div>
          <ReactToPrint
            trigger={() => {
              return (
                <Button
                  // disabled={
                  //   !participants.every((c) => c.status === "complete")
                  // }
                  variant="contained"
                >
                  print tag
                </Button>
              );
            }}
            content={() => componentRef.current}
          />
        </div>
      </div>
      <div ref={componentRef} className="p-3">
        {staff.map((c) => (
          <div
            style={{ minHeight: "50vh" }}
            className="d-flex align-items-start"
          >
            <div className="d-flex flex-wrap">
              <div style={{ width: 350 }} className="me-1 ms-2">
                <div className="text-center">
                  <div className="mb-3 d-flex justify-content-center">
                    <img
                      alt="Jamb Logo"
                      style={{ height: 80, width: 100 }}
                      src={logo}
                    />
                  </div>
                  <div className="mb-3">
                    <h6 style={{ textTransform: "uppercase" }}>
                      2024 POLICY MEETING & 4<sup>th</sup> Edition of NATAP-M
                      Awards
                    </h6>
                  </div>
                  <div className="mb-3 d-flex justify-content-center ">
                    <div style={{ height: 30 }}></div>
                    {/* <img
                      height={240}
                      width={240}
                      className="object-fit-fill "
                      //className="img-thumbnail"
                      src={staff.imageURL}
                      alt={staff.code}
                    /> */}
                  </div>

                  <h1
                    style={{
                      fontWeight: "700",
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {c.name}
                    {/* {staff.title} {staff.firstName}{" "}
                        {staff.lastName} */}
                  </h1>

                  <h4
                    style={{
                      fontWeight: "700",
                      textTransform: "uppercase",
                      margin: 0,
                    }}
                  >
                    {c.idCard}
                  </h4>
                </div>
              </div>
              <div
                className="d-flex align-items-center d-flex justify-content-center col-lg-12"
                style={{ width: 350 }}
              >
                <div className="text-center">
                  <p>
                    Thursday 18<sup>th</sup> July, 2024 <br />
                    Auditorium & Banquet Hall
                    <br />
                    Body of Benchers Headquarters
                    <br />
                    Abuja, FCT
                  </p>

                  <QRCode size={180} value={c._id} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default JambTagsPrintout;
